import { render, staticRenderFns } from "./statuses-list.vue?vue&type=template&id=b3949690&scoped=true"
import script from "./statuses-list.vue?vue&type=script&lang=js"
export * from "./statuses-list.vue?vue&type=script&lang=js"
import style0 from "./statuses-list.vue?vue&type=style&index=0&id=b3949690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3949690",
  null
  
)

export default component.exports